<template>
  <a-row :gutter="10">
    <a-col :md="8" :sm="24" style="border-right:1px solid #ccc;">
      <a-card :bordered="false">
        <!-- 按钮操作区域 -->
        <a-row style="margin-left: 14px">
          <a-button @click="handleAdd(2)" type="primary" v-if="permissions.includes('back:org:add')">添加子组织</a-button>
          <!-- <a-button @click="handleAdd(1)" type="default">添加一级部门</a-button> -->
          <a-button @click="handleRemove" type="default" v-if="permissions.includes('back:org:delete')">删除</a-button>
          <a-button @click="refresh" type="default" icon="reload" :loading="loading">刷新</a-button>
        </a-row>
        <!-- 树-->
        <a-col :md="10" :sm="24">
          <template>
            <a-tree
              @select="onSelect"
              :selectedKeys="selectedKeys"
              :treeData="departmentTree"
              :expandedKeys="iExpandedKeys"
              :autoExpandParent="autoExpandParent"
              @expand="onExpand"/>
          </template>
        </a-col>
      </a-card>
    </a-col>
    <a-col :md="16" :sm="24">
      <a-card :bordered="false">
        <a-form :form="form">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="组织名称">
            <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入组织名称' }] } ]"/>
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="简称">
            <a-input v-decorator="['shortName']"/>
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="组织编码">
            <a-input placeholder="请输入组织编码" v-decorator="['code']" disabled/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级组织">
            <a-tree-select
              style="width:100%"
              :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
              :treeData="treeData"
              disabled
              v-model="model.parentName">
            </a-tree-select>
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="排序">
            <a-input-number placeholder="请输入组织排序" style="width: 200px" v-decorator="[ 'orderCode' ]"/>
          </a-form-item>
          <a-form-item 
            label="备注" 
            :labelCol="labelCol" 
            :wrapperCol="wrapperCol">
            <a-textarea v-decorator="['remark']" :rows="4" />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="启用">
            <a-switch checkedChildren="是" unCheckedChildren="否" v-model="enable"/>
          </a-form-item>
        </a-form>
        <div class="anty-form-btn">
          <a-button @click="emptyCurrForm" type="default" htmlType="button" icon="sync">重置</a-button>
          <a-popconfirm :title="'确定要修改吗?'" okText="确定" cancelText="取消" @confirm="() => submitCurrForm()" v-if="permissions.includes('back:org:update')">
            <a-button type="primary" htmlType="button" icon="form">修改并保存</a-button>
          </a-popconfirm>
        </div>
      </a-card>
    </a-col>
    <department-modal ref="departmentModal" @ok="loadTree"></department-modal>
  </a-row>
</template>
<script>
import DepartmentModal from './modules/DepartmentModal'
import pick from 'lodash.pick'
import { queryDepartmentTreeList, removeDepartment, updateDepartment } from '@/baseAPI/department'
import { mapState } from 'vuex'
export default {
  name: 'DepartmentList',
  components: {
    DepartmentModal
  },
  computed: {
    ...mapState({
      permissions: state => state.user.permissions
    })
  },
  data () {
    return {
      enable: true,
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      treeData: [],
      departmentTree: [],
      model: {},
      selectedKeys: [],
      currSelected: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
  },
  methods: {
    loadTree () {
      const _this = this
      _this.treeData = []
      _this.departmentTree = []
      queryDepartmentTreeList().then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          const temp = res.data[i]
          _this.treeData.push(temp)
          _this.departmentTree.push(temp)
          _this.setThisExpandedKeys(temp)
        }
        this.loading = false
      })
    },
    setThisExpandedKeys (node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key)
        for (let a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a])
        }
      }
    },
    refresh () {
      this.loading = true
      this.loadTree()
    },
    onExpand (expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.iExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    handleRemove () {
      if (this.selectedKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return false
      } else {
        const _this = this
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中组织?',
          okText: '确认',
          cancelText: '取消',
          onOk: function () {
            removeDepartment(_this.selectedKeys[0]).then((res) => {
              _this.$notification.success({
                message: '提示',
                description: res.message || '删除选中组织成功',
                duration: 3
              })
              _this.loadTree()
              _this.onClearSelected()
            }).catch(err => {
              _this.$notification.error({
                message: '错误',
                description: ((err.response || {}).data || {}).message || '删除选中用户失败',
                duration: 3
              })
            })
          }
        })
      }
    },
    onSelect (selectedKeys, e) {
      const record = e.node.dataRef
      this.currSelected = Object.assign({}, record)
      this.model = this.currSelected
      this.selectedKeys = [record.key]
      // TreeSelect 指定当前选中的条目的类型需为string/string[]
      // this.model.parentId = record.parentId == null || record.parentId == 0 ? null : record.parentId.toString()
      if(record.parentId == null || record.parentId == 0){
        this.model.parentId=null
      }else{
        var obj=this.getParent(this.departmentTree,record.parentId)
        this.model.parentId=record.parentId.toString()
        this.model.parentName=obj.name
      }
      this.enable = record.enable
      // 为组织树右侧的form表单赋值
      this.form.setFieldsValue(pick(record, 'name', 'shortName', 'code', 'remark', 'orderCode'))
    },
    getParent(arr,id){
      for(let i=0;i<arr.length;i++){
        if(arr[i].id==id){
          return arr[i]
        }
        if(arr[i].children!=null){
          var obj=this.getParent(arr[i].children,id)
          if(obj!=''){
            return obj
          }
        }
      }
      return ''
    },
    onClearSelected () {
      this.checkedKeys = {}
      this.currSelected = {}
      this.form.resetFields()
      this.model.parentId = null
      this.selectedKeys = []
    },
    submitCurrForm () {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (!this.currSelected.id) {
            this.$message.warning('请点击选择要修改组织!')
            return
          }

          const formData = Object.assign(this.currSelected, values, { enable: this.enable })

          updateDepartment(formData).then(res => {
            if(res.data.success){
                this.$notification.success({
                  message: '提示',
                  description: res.message || '更新组织成功',
                  duration: 3
                })
              } else {
                this.$notification.error({
                  message: '错误',
                  description: res.data.errorMessage || '更新组织失败',
                  duration: 3
                })
              }
            this.loadTree()
          })
        }
      })
    },
    emptyCurrForm () {
      this.form.resetFields()
    },
    handleAdd (num) {
      if (num === 1) {
        this.$refs.departmentModal.add(null, this.treeData)
        this.$refs.departmentModal.title = '新增'
      } else if (num === 2) {
        const key = this.currSelected.key
        if (!key) {
          this.$message.warning('请先选中一条记录!')
          return false
        }
        this.$refs.departmentModal.add(this.selectedKeys, this.treeData)
        this.$refs.departmentModal.title = '新增'
      } else {
        this.$refs.departmentModal.add(this.rightClickSelectedKey, this.treeData)
        this.$refs.departmentModal.title = '新增'
      }
    }
  },
  created () {
    this.loadTree()
  }

}
</script>
<style scoped>
  .anty-form-btn {
    width: 100%;
    text-align: center;
  }

  .anty-form-btn button {
    margin: 0 5px;
  }

  .anty-node-layout .ant-layout-content {
    margin: 0 !important;
  }

  .anty-node-layout .ant-layout-header {
    padding-right: 0
  }

  .header {
    padding: 0 8px;
  }

  .header button {
    margin: 0 3px
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }

  #app .desktop {
    height: auto !important;
  }

  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }
</style>
